
// whether this is dev.lingoleaf.io
const IS_DEV_FRONTEND = window.location.href === 'https://dev.lingoleaf.io/' || window.location.href.startsWith('https://dev.lingoleaf.io')

// number of hints when you start leaf
const INITIAL_HINT_COUNT = 8;

// if tree has this week index or lower, then warning banner displayed
const EARLY_CONTENT_WARNING_WEEK = 5;

const LANGUAGE_NAMES = {
    'en': 'English',
    'de': 'Deutsch',
    'fr': 'Français',
    'es': 'Español',
    'ja': '日本語',
    'hi': 'हिन्दी',
}
const LEVEL_NAMES = {
  'beg': 'Beginner',
  'int': 'Intermediate',
  'adv': 'Advanced',
}

export { IS_DEV_FRONTEND, INITIAL_HINT_COUNT, EARLY_CONTENT_WARNING_WEEK, LANGUAGE_NAMES, LEVEL_NAMES, }